<template>
  <div class="loading-overlay fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50">
    <div class="bg-white rounded-lg p-8 shadow-2xl">
      <div class="flex flex-col items-center">
        <!-- Spinner -->
        <div class="relative">
          <div class="w-16 h-16 border-4 border-gray-200 rounded-full"></div>
          <div class="absolute top-0 left-0 w-16 h-16 border-4 border-pink-500 rounded-full border-t-transparent animate-spin"></div>
        </div>
        
        <!-- Loading Text -->
        <p class="mt-4 text-gray-700 font-medium">{{ loadingText }}</p>
        
        <!-- Progress Bar (optional) -->
        <div v-if="showProgress" class="mt-4 w-48">
          <div class="bg-gray-200 rounded-full h-2 overflow-hidden">
            <div 
              class="bg-pink-500 h-full rounded-full transition-all duration-300"
              :style="{ width: `${progress}%` }"
            ></div>
          </div>
          <p class="mt-2 text-sm text-gray-600 text-center">{{ progress }}%</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useAppStore } from '@/stores/app'

const appStore = useAppStore()

const loadingText = computed(() => appStore.loadingText || 'Caricamento in corso...')
const showProgress = computed(() => appStore.loadingProgress !== null)
const progress = computed(() => appStore.loadingProgress || 0)
</script>

<style scoped>
.loading-overlay {
  backdrop-filter: blur(2px);
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.animate-spin {
  animation: spin 1s linear infinite;
}
</style>
